import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";

import Captcha from "./Components/ReCaptcha/Captcha";
import Toaster from "./Components/Toaster/Toaster";
import ErrorPage from "./Pages/404error/error404";
import AddCardNew from "./Pages/AddCardNew/AddCardNew";
import AddNewCard from "./Pages/AddNewCard/AddNewCard";
import Checkout from "./Pages/Checkout/Checkout";
import CheckOutPage from "./Pages/CheckOutPage/CheckOutPage";
import ContactSeller from "./Pages/ContactSeller/ContactSeller";
import CouponDetails from "./Pages/CouponDetails/CouponDetails";
import CouponTransactions from "./Pages/CouponTransaction/CouponTransactions";
import CreateCoupons from "./Pages/CreateCoupons/CreateCoupons";
import { ViewCoupon } from "./Pages/CreateCoupons/ViewCoupon";
import CreateNewPassword from "./Pages/CreateNewPassword/CreateNewPassword";
import CreateVouchers from "./Pages/CreateVouchers/CreateVouchers";
import { ViewVoucher } from "./Pages/CreateVouchers/ViewVoucher";
import CustomerDetails from "./Pages/CustomerDetails/CustomerDetails";
import Dashboard from "./Pages/Dashboard/Dashboard";
import EditEmailAddress from "./Pages/EditEmailAddress/EditEmailAddress";
import EditMobileNumber from "./Pages/EditMobileNumber/EditMobileNumber";
import EditVoucher from "./Pages/EditVoucher/EditVoucher";
import EmailSent from "./Pages/EmailSent/EmailSent";
import Explore from "./Pages/Explore/Explore";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import Messages from "./Pages/Messages/Messages";
import MyAccCouponsDashboard from "./Pages/MyAccCouponsDashboard/MyAccCouponsDashboard";
import MyAccManageCoupons from "./Pages/MyAccManageCoupons/MyAccManageCoupons";
import MyAccManageVouchers from "./Pages/MyAccManageVouchers/MyAccManageVouchers";
import MyAccVouchersDashboard from "./Pages/MyAccVouchersDashboard/MyAccVouchersDashboard";
import MyCoupons from "./Pages/MyCoupons/MyCoupons";
import MyProfileBankInfoPage from "./Pages/MyProfileBankInfoPage/MyProfileBankInfoPage";
import MyProfileBusinessinfoPage from "./Pages/MyProfileBusinessinfoPage/MyProfileBusinessinfoPage";
import MyProfileGeneralInfoPage from "./Pages/MyProfileGeneralInfoPage/MyProfileGeneralInfoPage";
import MyProfileMarketMembershipPage from "./Pages/MyProfileMarketMembershipPage/MyProfileMarketMembershipPage";
import MyProfileResetPassword from "./Pages/MyProfileResetPassword/MyProfileResetPassword";
import MyProfileStoreInfoPage from "./Pages/MyProfileStoreInfoPage/MyProfileStoreInfoPage";
import MyProfileSubscriptionPage from "./Pages/MyProfileSubscriptionPage/MyProfileSubscriptionPage";
import MyProfileSubscriptionPageLock from "./Pages/MyProfileSubscriptionPageLock/MyProfileSubscriptionPageLock";

import MyProfileSubscriptionPlanDetails from "./Pages/MyProfileSubscriptionPlanDetails/MyProfileSubscriptionPlanDetails";
import MyVouchers from "./Pages/MyVouchers/MyVouchers";
import Notifications from "./Pages/Notifications/Notifications";
import OTP from "./Pages/OTP/OTP";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import RedeemConfirmation from "./Pages/RedeemConfirmation/RedeemConfirmation";
import RedeemVerification from "./Pages/RedeemVerification/RedeemVerification";
import ShopLocalBusinessProfilePage from "./Pages/ShopLocalAIBusinessProfile/ShopLocalBusinessProfilePage";
import ShopLocalCouponPage from "./Pages/ShopLocalCoupon/ShopLocalCouponPage";
import ShopLocalVoucherPage from "./Pages/ShopLocalVoucher/ShopLocalVoucherPage";
import SignIn from "./Pages/SignIn/SignIn";
import SignUp from "./Pages/SignUp/SignUp";
import CreatePasswordPage from "./Pages/SignUpVerificationPages/CreatePasswordPage/CreatePasswordPage";
import VerifyEmail from "./Pages/SignUpVerificationPages/VerifyEmail/VerifyEmail";
import VerifyOTP from "./Pages/SignUpVerificationPages/VerifyOTP/VerifyOTP";
import TermsAndConditions from "./Pages/TermsAndConditions/TermsAndConditions";
import TransactionFailed from "./Pages/TransactionFailed/TransactionFailed";
import TransactionsInnerTransaction from "./Pages/TransactionsInnerTransaction/TransactionsInnerTransaction";
import TransactionSuccessful from "./Pages/TransactionSuccessful/TransactionSuccessful";
import VoucherDetails from "./Pages/VoucherDetails/VoucherDetails";
import VoucherTransactions from "./Pages/VoucherTransactions/VoucherTransactions";
import MyProfileAddBussinessOTP from "./Pages/MyProfileAddBussinessOTP/MyProfileAddBussinessOTP";
import ManageBusiness from "./Pages/Manage Business/ManageBusiness";
import MyProfileAddBussiness from "./Pages/MyProfileAddBussiness/MyProfileAddBussiness";
import {
  getCheckChargebeeSubscription,
  setSubscriptionRenewStatus,
  setSubscriptionRenewMessage,
} from "./redux/CheckChargebeeSubscriptionSlice";
import { CheckChargeBeeSubscriptionApi } from "./Utils/Api/CheckChargeBeeSubscriptionApi";
import {
  userId,
  getactiveBuId,
  getBusinessSwitched,
} from "./Utils/LocalStorage";
import RedirectLoginUserAuth from "./Utils/RedirectLoginUserAuth";
import RequireAuth from "./Utils/RequireAuth";
import CloneCoupon from "./Pages/CloneCoupon/CloneCoupon";
import EditCoupon from "./Pages/EditCoupon/EditCoupon";

function App() {
  const [status, setStatus] = useState("");
  const [mobile, setMobile] = useState("");

  const manageStatus = (val) => setStatus(val);
  const manageMobile = (val) => setMobile(val);

  const location = useLocation();
  const navigate = useNavigate();
  const Uid = userId();
  const dispatch = useDispatch();

  const ReduxData = useSelector((state) => state.CheckChargebee);
  const { CheckChargebeeSubscription, subscrption_renew_status } = ReduxData;

  const PrivateRoutes = [
    { id: 0, path: "/explore", element: <Explore /> },
    { id: 2, path: "/dashboard", element: <Dashboard /> },
    { id: 3, path: "/voucherdetail/:id", element: <VoucherDetails /> },
    { id: 4, path: "/my-account/my-vouchers", element: <MyVouchers /> },
    { id: 5, path: "/redeemconfirmation/:id", element: <RedeemConfirmation /> },
    { id: 6, path: "/redeemverification/:id", element: <RedeemVerification /> },
    { id: 7, path: "/contactseller", element: <ContactSeller /> },
    {
      id: 8,
      path: "/my-profile/general-info",
      element: <MyProfileGeneralInfoPage />,
    },
    {
      id: 9,
      path: "/edit-mobile-number",
      element: <EditMobileNumber mobile={manageMobile} />,
    },
    {
      id: 10,
      path: "/edit-email-address",
      element: <EditEmailAddress email_prop={manageMobile} />,
    },
    { id: 11, path: "/notifications", element: <Notifications /> },
    {
      id: 12,
      path: "/myprofile-resetpadssword",
      element: <MyProfileResetPassword />,
    },
    { id: 13, path: "/checkout", element: <Checkout /> },
    { id: 14, path: "/addnewcard", element: <AddNewCard /> },
    { id: 15, path: "/messages/:id", element: <Messages /> },
    { id: 16, path: "/my-account/my-coupons", element: <MyCoupons /> },
    { id: 17, path: "/coupondetail/:id", element: <CouponDetails /> },
    { id: 18, path: "/redeemconfirmation", element: <RedeemConfirmation /> },
    {
      id: 19,
      path: "/redeemverfication",
      element: <RedeemVerification mobile={mobile} />,
    },
    {
      id: 20,
      path: "/my-account/vouchers-dashboard",
      element: <MyAccVouchersDashboard />,
    },
    {
      id: 21,
      path: "/transactions/vouchers",
      element: <VoucherTransactions />,
    },
    {
      id: 22,
      path: "/my-profile/business-info",
      element: <MyProfileBusinessinfoPage />,
    },
    {
      id: 23,
      path: "/my-account/create-vouchers",
      element: <CreateVouchers />,
    },
    { id: 25, path: "/my-account/create-coupons", element: <CreateCoupons /> },
    {
      id: 26,
      path: "/my-account/view-voucher/:voucherId",
      element: <ViewVoucher />,
    },
    {
      id: 27,
      path: "/my-account/clone-voucher/:id/:flag",
      element: <EditVoucher edit={true} />,
    },
    {
      id: 28,
      path: "/my-account/view-coupon/:couponId",
      element: <ViewCoupon />,
    },
    {
      id: 29,
      path: "/my-account/clone-coupon/:id/:flag",
      element: <CloneCoupon />,
    },
    {
      id: 51,
      path: "/my-account/edit-coupon/:id",
      element: <EditCoupon />,
    },
    { id: 30, path: "/email-sent", element: <EmailSent /> },
    { id: 31, path: "/customer-details", element: <CustomerDetails /> },
    { id: 32, path: "/transactions/coupons", element: <CouponTransactions /> },
    {
      id: 33,
      path: "/my-account/manage-vouchers",
      element: <MyAccManageVouchers />,
    },
    {
      id: 34,
      path: "/my-account/coupons-dashboard",
      element: <MyAccCouponsDashboard />,
    },
    {
      id: 35,
      path: "/my-account/manage-coupons",
      element: <MyAccManageCoupons />,
    },
    {
      id: 36,
      path: "/my-profile/store-info",
      element: <MyProfileStoreInfoPage />,
    },
    {
      id: 37,
      path: "/my-profile/bank-info",
      element: <MyProfileBankInfoPage />,
    },
    {
      id: 38,
      path: "/my-profile/marketplace-membership",
      element: <MyProfileMarketMembershipPage />,
    },
    { id: 39, path: "/captcha/box", element: <Captcha /> },
    {
      id: 40,
      path: "/my-profile/subscription",
      element: <MyProfileSubscriptionPage />,
    },
    {
      id: 43,
      path: "/my-profile/subscription/tier-details",
      element: <MyProfileSubscriptionPlanDetails />,
    },
    {
      id: 45,
      path: "/my-profile/subscription/checkOutPage",
      element: <CheckOutPage />,
    },
    {
      id: 46,
      path: "/transactions/inner-transactions",
      element: <TransactionsInnerTransaction />,
    },
    { id: 47, path: "/my-profile/add-card", element: <AddCardNew /> },
    {
      id: 48,
      path: "/my-profile/transaction-failed",
      element: <TransactionFailed />,
    },
    {
      id: 49,
      path: "/my-profile/transaction-successful",
      element: <TransactionSuccessful />,
    },
    {
      id: 50,
      path: "/my-profile/MyProfileSubscription-Lock",
      element: <MyProfileSubscriptionPageLock />,
    },
    {
      id: 51,
      path: "/shop-local-AI/business-profile",
      element: <ShopLocalBusinessProfilePage />,
    },
    {
      id: 52,
      path: "/shop-local-AI/voucher",
      element: <ShopLocalVoucherPage />,
    },
    { id: 53, path: "/shop-local-AI/coupon", element: <ShopLocalCouponPage /> },
    {
      id: 54,
      path: "/my-profile/manage-business",
      element: <ManageBusiness />,
    },
  ];

  // API call to check subscription
  const CheckChargeBeeSubscriptionAPIHandler = async () => {
    const is_switched_value = getBusinessSwitched();
    const acitve_business_id = getactiveBuId();
    const data = {
      user_id:
        is_switched_value === "true"
          ? parseInt(acitve_business_id)
          : parseInt(Uid),
    };

    const res = await CheckChargeBeeSubscriptionApi(data, () => navigate("/"));
    if (!res) return;

    dispatch(getCheckChargebeeSubscription(res.lock_profile));
    dispatch(setSubscriptionRenewStatus(res.subscrption_renew_status || false));
    dispatch(setSubscriptionRenewMessage(res.renew_message || ""));
  
  };

  useEffect(() => {
    CheckChargeBeeSubscriptionAPIHandler();
  }, [location.pathname]);

  // Private route wrapper for locked subscription
  // const PrivateRouteWrapper = ({ children }) => {
  //   return subscrption_renew_status ? children : <MyProfileSubscriptionPageLock />;
  // };

  // console.log("ReduxData", ReduxData.subscrption_renew_status);
  // console.log("CheckChargebeeSubscription", ReduxData.CheckChargebeeSubscription);

  return (
    <>
      <Toaster />
      <div className={CheckChargebeeSubscription ? "App app_Locked" : "App"}>
        <Routes>
          <Route
            path="/"
            element={
              <RedirectLoginUserAuth>
                <SignIn />
              </RedirectLoginUserAuth>
            }
          />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="*" element={<ErrorPage />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/signup/OTP" element={<VerifyOTP />} />
          <Route
            path="/signup/OTP/createpassword"
            element={<CreatePasswordPage />}
          />
          <Route path="/SignedUpSuccesfully" element={<VerifyEmail />} />
          <Route path="/signup" element={<SignUp Status={manageStatus} />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/createnewpassword" element={<CreateNewPassword />} />
          <Route path="/otp" element={<OTP />} />
          <Route
            path="/my-profile/addbusiness/otp"
            element={
              <RequireAuth>
                <MyProfileAddBussinessOTP />
              </RequireAuth>
            }
          />
          <Route
            path="/my-profile/addbusiness/Email"
            element={
              <RequireAuth>
                <MyProfileAddBussiness />
              </RequireAuth>
            }
          />

          {PrivateRoutes.map((r) => (
            <Route
              key={r.id}
              path={r.path}
              element={<RequireAuth Path={r.path}>{r.element}</RequireAuth>}
            />
          ))}
        </Routes>
      </div>
    </>
  );
}

export default App;
